import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';
import { Card } from './ui/card';
import { PhoneCall, Lock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * A provider's own answered-call counter. Private: only the provider sees it
 * on their profile (admins see the same numbers from their dashboard).
 */
export const CallCountCard = () => {
  const { t } = useLanguage();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/providers/me/call-stats`, { withCredentials: true })
      .then((r) => setStats(r.data))
      .catch(() => setStats(null));
  }, []);

  if (!stats) return null;

  const cells = [
    { key: 'total', ar: 'الإجمالي', en: 'Total calls', value: stats.total },
    { key: 'this_month', ar: 'هذا الشهر', en: 'This month', value: stats.this_month },
    { key: 'today', ar: 'اليوم', en: 'Today', value: stats.today },
  ];

  return (
    <Card className="p-6" data-testid="provider-call-count-card">
      <div className="flex items-center justify-between mb-4 gap-2">
        <h2 className="text-xl font-bold text-[#2c3e50] flex items-center gap-2">
          <PhoneCall size={18} className="text-[#1565c0]" />
          {t('عدد المكالمات', 'Calls answered')}
        </h2>
        <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-gray-500 bg-gray-100 rounded-full px-2 py-1">
          <Lock size={11} />
          {t('خاص بك فقط', 'Private to you')}
        </span>
      </div>
      <div className="grid grid-cols-3 gap-3">
        {cells.map((c) => (
          <div key={c.key} className="rounded-xl bg-blue-50 py-4 text-center">
            <p className="text-2xl font-extrabold text-[#0d47a1]" data-testid={`call-count-${c.key}`}>
              {c.value ?? 0}
            </p>
            <p className="text-xs font-semibold text-gray-600 mt-1">{t(c.ar, c.en)}</p>
          </div>
        ))}
      </div>
      {stats.psychology > 0 && (
        <p className="text-xs text-gray-500 mt-3" data-testid="call-count-psychology">
          {t(`منها ${stats.psychology} جلسة نفسية`, `${stats.psychology} of them psychology sessions`)}
        </p>
      )}
    </Card>
  );
};

export default CallCountCard;
